import { createContext, useEffect, useMemo, useState } from "react";
import { SIM_BUILDER_API_END_POINT } from "../Config";
import tokenManager from "../utils/tokenManager";

export const UserContext = createContext();

const UserContextProvider = (props) => {
  const [user, setUser] = useState(() => {
    let user = null;
    try {
      user = JSON.parse(localStorage.getItem("user"));
    } catch (error) {
      console.error(error.message);
    }
    return user ? user : null;
  });

  const [token, setToken] = useState(() => {
    let token = null;
    try {
      token = localStorage.getItem("token");
    } catch (error) {
      console.error(error.message);
    }
    return token ? token : null;
  });

  useEffect(() => {
    tokenManager.setToken(token);
  }, [token]);

  useEffect(() => {
    tokenManager.setOnTokenUpdate((newToken, newUser) => {
      setToken(newToken);
      if (newUser) {
        setUser(newUser);
      }
    });

    tokenManager.setOnLogout(() => {
      localStorage.clear();
      setUser(null);
      setToken(null);
    });
  }, []);

  const logout = async () => {
    try {
      await fetch(SIM_BUILDER_API_END_POINT + "/auth/logout", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
    } catch (error) {
      console.error("Logout server call failed:", error.message);
    }
    try {
      localStorage.clear();
      setUser(null);
      setToken(null);
    } catch (error) {
      console.error(error.message);
    }
  };

  const userContext = useMemo(
    () => ({
      user,
      setUser,
      token,
      setToken,
      logout,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token]
  );

  return (
    <UserContext.Provider value={{ ...userContext }}>
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
